import { useAuth } from "../../../context";
import { useMutation, useQuery } from "react-query";
import { Decarbonization } from "../../../api/decarbonization";

export const decarbonizationKeys = {
  all: () => ["decarbonization"],
  chartData: () => ["chartData"]
};

export function useGetDecarbonization(config) {
  const { callApi } = useAuth();
  return useQuery(decarbonizationKeys.all(),
    () => callApi(Decarbonization.getDecarbonization), config);
}

export function useGetChartData(config) {
  const { callApi } = useAuth();
  return useQuery([...decarbonizationKeys.all(), ...decarbonizationKeys.chartData()],
    () => callApi(Decarbonization.getChartData), config);
}

export function useUpdateDecarbonization(config) {
  const { callApi } = useAuth();
  return useMutation(data => callApi(Decarbonization.updateDecarbonization, data), config);
}

export function useLoadLevers(config) {
  const { callApi } = useAuth();
  return useMutation(() => callApi(Decarbonization.loadLevers), config);
}

export function useUpdatePathwaySelection(config) {
  const { callApi } = useAuth();
  return useMutation(data => callApi(Decarbonization.updatePathwaySelection, data), config);
}

export function useUpdateEstimatedGrowth(config) {
  const { callApi } = useAuth();
  return useMutation(data => callApi(Decarbonization.updateEstimatedGrowth, data), config);
}

export function useExportDecarbonizationData(config) {
  const { callApi } = useAuth();
  return useMutation( year => callApi(Decarbonization.exportDecarbonizationData, year), config);
}